import React from "react";
import useDimensions from "react-use-dimensions";
import { Clusterer, Map, Placemark, YMaps } from "react-yandex-maps";

import styled from "styled-components";

export default function YaMap(props) {
    const { onSelect = (x) => {}, dorms = [] } = props;

    const [ref, { x, y, width, height }] = useDimensions();

    if (dorms.length == 0) {
        return <div>-</div>;
    }

    let items = dorms
        .map((a) => {
            let details = a?.details || {};
            let mainInfo = details["main-info"] || {};
            let coordinates = mainInfo?.coordinates || {};
            let { lat, lng } = coordinates;
            return {
                ...a,
                lat: lat,
                lng: lng,
            };
        })
        .filter((x) => !(x.lat == undefined || x.lng == undefined));
    let firstItem = items == undefined || items.length == 0 ? undefined : items[0];
    if (firstItem == undefined) {
        return null;
    }

    return (
        <Wrapper ref={ref}>
            <YMaps>
                <Map
                    width={width}
                    height={height}
                    defaultState={{
                        center: [firstItem?.lat ? +firstItem?.lat : 75.75, firstItem?.lng ? +firstItem?.lng : 47.57],
                        zoom: window.innerWidth < 820 ? 2 : 3,
                    }}
                    onClick={(x, y) => {}}
                >
                    {items.length == 0 ? null : (
                        <Clusterer
                            options={{
                                preset: "islands#invertedYellowClusterIcons",
                                groupByCoordinates: false,
                            }}
                        >
                            {items.map((a, index) => (
                                <Placemark
                                    id={a.id}
                                    options={{
                                        preset: `islands#yellowStarCircleIcon`,
                                    }}
                                    key={index}
                                    geometry={[+a.lat, +a.lng]}
                                    onClick={(x, y) => {
                                        console.log("---> onClick: x, y = ", x, y);
                                        const [lat_, lng_] = x.get("coords");
                                        console.log("lat_, lng_ = ", lat_, lng_);
                                        let xItems = items
                                            .filter((x) => x.lat != undefined && x.lng != undefined)
                                            .map((a, i) => {
                                                let dx = +a.lat - +lat_;
                                                let dy = +a.lng - +lng_;
                                                let dist = dy * dy + dx * dx;
                                                return {
                                                    ...a,
                                                    dist: dist,
                                                };
                                            })
                                            .sort((a, b) => +a.dist - +b.dist);
                                        let el = xItems.length == 0 ? undefined : xItems[0];
                                        console.log("--->> el = ", el);
                                        if (el != undefined) {
                                            onSelect(el);
                                        }
                                    }}
                                />
                            ))}
                        </Clusterer>
                    )}
                </Map>
            </YMaps>
        </Wrapper>
    );
}

const LoadingPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Wrapper = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
`;
